import React from 'react';
import PageHeader from '../components/PageHeader';
import TeamSection from '../components/TeamSection';

const Team = () => {
  const breadcrumb = [
    { label: 'Home', href: '/' },
    { label: 'Pages', href: '#' },
    { label: 'Our Team', href: '/team', active: true }
  ];

  return (
    <>
      <PageHeader title="Our Team" breadcrumb={breadcrumb} />
      <TeamSection />
    </>
  );
};

export default Team;






